(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalReportThirdPartyReviewController', AppraisalReportThirdPartyReviewController);

    AppraisalReportThirdPartyReviewController.$inject = ['$scope', '$state', '$stateParams', '$sce', '$rootScope', '$mdDialog', 'report', 'order', 'account',
                                                'reportSubmittable', 'AppraisalReport', 'Principal', 'validationErrors', 'AppraiserUser',
                                                '$location', '$anchorScroll', 'LocalStorage', 'AppraisalState', 'reportErrors', '$log', 'OrderSummaryNav'];

    function AppraisalReportThirdPartyReviewController($scope, $state, $stateParams, $sce, $rootScope, $mdDialog, report, order, account,
                                                reportSubmittable, AppraisalReport, Principal, validationErrors, AppraiserUser,
                                                $location, $anchorScroll, LocalStorage, AppraisalState, reportErrors, $log, OrderSummaryNav) {
        var vm = this;

        // Collapsible //
        var collapsibleStoreId = 'appraisal_report_review_open_errors_' + report.id + '_' + (account ? account.id : "");
        vm.isOpen = LocalStorage.HasModel(collapsibleStoreId);
        vm.toggleOpen = function() {
            vm.isOpen = !vm.isOpen;
            vm.isOpen ? LocalStorage.SaveModel(collapsibleStoreId, true) : LocalStorage.ClearModel(collapsibleStoreId);
        };
        vm.account = account;

        // Model //
        vm.appraisalReport = report;
        vm.appraisalOrder = order;

        vm.validationErrors = validationErrors;
        vm.hasValidationErrors = Object.keys(vm.validationErrors).filter(function(key) {
            return !key.startsWith('$') && vm.validationErrors[key].length > 0;
        }).length > 0;
        vm.reportErrors = reportErrors;
        vm.hasErrors = Object.keys(vm.reportErrors).some(function(key) { return vm.reportErrors[key]; });

        vm.version = null;

        vm.reportSubmittable = reportSubmittable;
        vm.canSubmit = !vm.hasErrors && (!AppraisalState.inAnyState(vm.appraisalOrder, AppraisalState.submitted) || vm.appraisalOrder.state === 'RESUBMISSION_REQUIRED');

        // Set redacted based on the user's effective report access level
        vm.canToggleRedacted = false;
        Principal.matchAnyAuthority(/^ROLE_ORIGINATOR.*/).then(function(hasAuth) {
            if (hasAuth) {
                var hasFull = account && account.effectiveReportAccessLevel === 'FULL';
                vm.redacted = !hasFull;
                vm.canToggleRedacted = hasFull;
            }
            // Set PDF URL after role check completes
            initReport();
        });

        // Methods //
        vm.initReport = initReport;
        vm.hasReport = hasReport;
        vm.submitReport = submitReport;
        vm.submitReportOriginatorOnly = submitReportOriginatorOnly;
        vm.acceptReport = acceptReport;
        vm.declineReport = declineReport;
        vm.goToActions = goToActions;
        vm.goToReport = goToReport;

        if (vm.isLender === false) {
            Principal.matchAnyAuthority(/^ROLE_ORIGINATOR.*/).then(function(hasAuth) {
                if (hasAuth) vm.acceptMessage = 'The report that you have reviewed meets your expectations?';
            });

            Principal.matchAnyAuthority(/^ROLE_VC.*/).then(function(hasAuth) {
                if (hasAuth) vm.acceptMessage = 'Would you like to release this report to the end users?';
            });
        }

        /**
         * Set the PDF URL and retrieve the HTML version from the server
         * @return {Promise} Promise that is resolved when the HTML report is done generating
         */
        function initReport() {
            // Set the generated pdf url
            var tempUrl = "/api/appraisal-reports/generate-pdf/" + vm.appraisalReport.id + "?version=" + (vm.version || "");
            if (vm.redacted) tempUrl += "&redacted=true";
            vm.appraisalReportPdfUrl = $sce.trustAsResourceUrl(tempUrl);
        }

        function hasReport() {
            var hasMainReport = !vm.validationErrors.thirdParty.some(function(err) { return err.fieldKey === 'thirdParty.report'; });
            
            // For originators: bypass main report validation errors (they can access via redacted/fallback logic)
            // Check if user has originator authority by checking vm.account authorities
            var isOriginator = vm.account && vm.account.authorities && 
                vm.account.authorities.some(function(auth) { return auth.indexOf('ROLE_ORIGINATOR') === 0; });
                
            if (isOriginator && !hasMainReport) {
                return true; // Allow originators to bypass main report validation issues
            }
            
            // For non-originators: enforce original validation logic
            if (!hasMainReport) vm.isOpen = true;

            return hasMainReport;
        }

        function acceptReport(ev) {
            var confirm = $mdDialog.confirm()
                .title('Accept Report')
                .textContent(vm.acceptMessage)
                .ariaLabel('Accept and Release Report')
                .targetEvent(ev)
                .ok('Accept')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                AppraisalReport.acceptReport({id:vm.appraisalReport.id}, {}, function(data){
                    $state.go("home");
                });
            });
        }

        function declineReport(ev) {
            $mdDialog.show({
                templateUrl: 'app/entities/appraisal-report/appraisal-report-decline-dialog.html',
                controller: 'AppraisalReportDeclineController',
                controllerAs: 'vm',
                fullscreen: true,
                locals: {
                    report: report,
                    order: order
                }
            }).then(function() {
                $state.go('appraisal-report-review-third-party', null, { reload: true });
            }, function() {
                $state.go('appraisal-report-review-third-party');
            });
        }

        function submitReport(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
        	if(vm.appraisalOrder.lender && vm.appraisalOrder.lender.sendReportToCCR){
        		var confirm = $mdDialog.confirm(ev)
                	.title('Submit Report')
                	.htmlContent("By selecting 'OK' you are acknowledging your confidence in the report being submitted.<br><font color=\"red\"> ATTENTION: The authorized user does not receive reports through Value Connect. Please send the report to the authorized user directly and cc appraisals@valueconnect.ca</font>")
                	.ariaLabel('Submit Report')
                	.targetEvent(ev)
                	.ok('OK')
                	.cancel('Cancel');
        	}else{
        		var confirm = $mdDialog.confirm(ev)
            	.title('Submit Report')
            	.htmlContent("By selecting 'OK' you are acknowledging your confidence in the report being submitted.<br> Your report will be sent to the lender through the VC portal. No further action is required. Thank you!")
            	.ariaLabel('Submit Report')
            	.targetEvent(ev)
            	.ok('OK')
            	.cancel('Cancel');

        	}

            $mdDialog.show(confirm).then(function() {
                AppraisalReport.submitReport({id:vm.appraisalReport.id}, {}, function(data) {
                    OrderSummaryNav.goToOrderSummary(vm.appraisalOrder.id);
                });
            });
        }

        function submitReportOriginatorOnly(ev) {
            var confirm = $mdDialog.confirm(ev)
                .title('Send Report To Originator')
                .htmlContent("By selecting 'OK' you are acknowledging your confidence in the report being submitted.<br> Your report will be sent to the originator only. The report will remain in its current state until it is later submitted to a lender.")
                .ariaLabel('Send Only to Originator')
                .targetEvent(ev)
                .ok('OK')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function() {
                AppraisalReport.submitReportOriginatorOnly({id:vm.appraisalReport.id}, {}, function(data) {
                    // Stay on the current page instead of redirecting
                    // $state.go('appraisal-order-detail', { 'id' : vm.appraisalOrder.id});
                });
            });
        }

        function goToActions() {
            $location.hash('actions');
            $anchorScroll();
        }

        function goToReport() {
            $location.hash('report');
            $anchorScroll();
        }

        var unsubscribe = $rootScope.$on('valueconnectApp:appraisalReportUpdate', function(event, result) {
            vm.appraisalReport = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
